// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "../application";

import ActivationSectionController from "./activation_section_controller";
application.register("activation-section", ActivationSectionController);

import AnalyticsController from "./analytics_controller";
application.register("analytics", AnalyticsController);

import CourseController from "./course_controller";
application.register("course", CourseController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import WistiaController from "./wistia_controller";
application.register("wistia", WistiaController);

import WistiaThumbnailController from "./wistia_thumbnail_controller";
application.register("wistia-thumbnail", WistiaThumbnailController);

import AutoSubmitFormController from "../shared/auto_submit_form_controller";
application.register("auto-submit-form", AutoSubmitFormController);

import CheckboxSelectionController from "../shared/checkbox_selection_controller";
application.register("checkbox-selection", CheckboxSelectionController);

import ClipboardController from "../shared/clipboard_controller";
application.register("clipboard", ClipboardController);

import ElementsController from "../shared/elements_controller";
application.register("elements", ElementsController);

import ScrollableRegionController from "../shared/scrollable_region_controller";
application.register("scrollable-region", ScrollableRegionController);

import ToggleController from "../shared/toggle_controller";
application.register("toggle", ToggleController);

import TomSelectController from "../shared/tom_select_controller";
application.register("tom-select", TomSelectController);

import WindowController from "../shared/window_controller";
application.register("window", WindowController);
